import { useRouterTrackEventName } from "@/hooks/use-router-page-title";
import { useTracker } from "@/hooks/use-tracker";
import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

/**
 * Tracks page view with the event name from `createPageRoute({ staticData: { eventName: string } })`.
 */
export const PageViewTracker = () => {
  const { track } = useTracker();
  const trackRef = useRef(track);
  trackRef.current = track;
  const pageCounter = useRef<number>(1);
  const lastPathnameRef = useRef<string>("");

  const eventName = useRouterTrackEventName();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  useEffect(() => {
    if (lastPathnameRef.current !== pathname) {
      const timeout = setTimeout(() => {
        lastPathnameRef.current = pathname;
        trackRef.current(eventName, {
          page_counter: pageCounter.current,
        });
        pageCounter.current++;
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [pathname, eventName]);

  return null;
};
